var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopyBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7332 5.53333H11.6665V7.13332H12.7332C13.1999 7.13332 13.5332 7.46666 13.5332 7.93332V12.7333C13.5332 13.2 13.1999 13.5333 12.7332 13.5333H7.9332C7.46654 13.5333 7.1332 13.2 7.1332 12.7333V11.8H5.5332V12.7333C5.5332 14.0667 6.59987 15.1333 7.9332 15.1333H12.7332C14.0665 15.1333 15.1332 14.0667 15.1332 12.7333V7.93332C15.1332 6.59999 14.0665 5.53333 12.7332 5.53333Z",
    fill: "#46474C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2667 2.4667C2.80003 2.4667 2.4667 2.80003 2.4667 3.2667V8.0667C2.4667 8.53337 2.80003 8.8667 3.2667 8.8667H8.0667C8.53337 8.8667 8.8667 8.53337 8.8667 8.0667V3.2667C8.8667 2.80003 8.53337 2.4667 8.0667 2.4667H3.2667ZM8.0667 10.4667H3.2667C1.93337 10.4667 0.866699 9.40003 0.866699 8.0667V3.2667C0.866699 1.93337 1.93337 0.866699 3.2667 0.866699H8.0667C9.40003 0.866699 10.4667 1.93337 10.4667 3.2667V8.0667C10.4667 9.40003 9.40003 10.4667 8.0667 10.4667Z",
    fill: "#46474C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyBlack);
export default __webpack_public_path__ + "static/media/icon_copy_black.71b2eaa578e5aa0df1fcfa100e40a49a.svg";
export { ForwardRef as ReactComponent };